import React from 'react'

export default function NotFound() {
    return (
        <section className="notfound">
            Not Found 404 
        </section>
    )
}
